import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Forgotten password route
 *
 * @extends KernelRoute
 */
class ForgottenPasswordRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/forgot-password(/)")
    route () {
        App.hideNavigation();

        System.import("./index").then(View => {
            const view = new View.default();
            raf(_ => App.contentRegion.show(view));
        });
    }
}

export default ForgottenPasswordRoute;



// WEBPACK FOOTER //
// ./public/domain/views/forgotten-password/forgotten-password.route.js